module.exports = __webpack_public_path__ + "static/media/serial-number.e5bec595.svg";